const userConstants = {
  SIGNUP_REQUEST: 'USERS_SIGNUP_REQUEST',
  SIGNUP_SUCCESS: 'USERS_SIGNUP_SUCCESS',
  SIGNUP_FAILURE: 'USERS_SIGNUP_FAILURE',

  SIGNUP_RESEND_CODE_REQUEST: 'USERS_SIGNUP_RESEND_CODE_REQUEST',
  SIGNUP_RESEND_CODE_SUCCESS: 'USERS_SIGNUP_RESEND_CODE_SUCCESS',
  SIGNUP_RESEND_CODE_FAILURE: 'USERS_SIGNUP_RESEND_CODE_FAILURE',

  SIGNUP_CONFIRMATION_REQUEST: 'USERS_SIGNUP_CONFIRMATION_REQUEST',
  SIGNUP_CONFIRMATION_SUCCESS: 'USERS_SIGNUP_CONFIRMATION_SUCCESS',
  SIGNUP_CONFIRMATION_FAILURE: 'USERS_SIGNUP_CONFIRMATION_FAILURE',

  SIGNIN_REQUEST: 'USERS_SIGNIN_REQUEST',
  SIGNIN_SUCCESS: 'USERS_SIGNIN_SUCCESS',
  SIGNIN_CHALLENGE: 'USERS_SIGNIN_CHALLENGE',
  SIGNIN_FAILURE: 'USERS_SIGNIN_FAILURE',

  SIGNOUT_REQUEST: 'USERS_SIGNOUT_REQUEST',
  SIGNOUT_SUCCESS: 'USERS_SIGNOUT_SUCCESS',
  SIGNOUT_FAILURE: 'USERS_SIGNOUT_FAILURE',

  CURRENT_SESSION_REQUEST: 'USERS_CURRENT_SESSION_REQUEST',
  CURRENT_SESSION_SUCCESS: 'USERS_CURRENT_SESSION_SUCCESS',
  CURRENT_SESSION_FAILURE: 'USERS_CURRENT_SESSION_FAILURE',

  FORGOT_PASSWORD_CODE_REQUEST: 'USERS_FORGOT_PASSWORD_CODE_REQUEST',
  FORGOT_PASSWORD_CODE_SUCCESS: 'USERS_FORGOT_PASSWORD_CODE_SUCCESS',
  FORGOT_PASSWORD_CODE_FAILURE: 'USERS_FORGOT_PASSWORD_CODE_FAILURE',

  FORGOT_PASSWORD_RESEND_CODE_REQUEST: 'USERS_FORGOT_PASSWORD_RESEND_CODE_REQUEST',
  FORGOT_PASSWORD_RESEND_CODE_SUCCESS: 'USERS_FORGOT_PASSWORD_RESEND_CODE_SUCCESS',
  FORGOT_PASSWORD_RESEND_CODE_FAILURE: 'USERS_FORGOT_PASSWORD_RESEND_CODE_FAILURE',

  FORGOT_PASSWORD_UPDATE_REQUEST: 'USERS_FORGOT_PASSWORD_UPDATE_REQUEST',
  FORGOT_PASSWORD_UPDATE_SUCCESS: 'USERS_FORGOT_PASSWORD_UPDATE_SUCCESS',
  FORGOT_PASSWORD_UPDATE_FAILURE: 'USERS_FORGOT_PASSWORD_UPDATE_FAILURE',

  GET_REQUEST: 'USERS_GET_REQUEST',
  GET_SUCCESS: 'USERS_GET_SUCCESS',
  GET_FAILURE: 'USERS_GET_FAILURE',

  UPDATE_REQUEST: 'USERS_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'USERS_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'USERS_UPDATE_FAILURE',

  UPDATE_MEMBERSHIP_REQUEST: 'USERS_UPDATE_MEMBERSHIP_REQUEST',
  UPDATE_MEMBERSHIP_SUCCESS: 'USERS_UPDATE_MEMBERSHIP_SUCCESS',
  UPDATE_MEMBERSHIP_FAILURE: 'USERS_UPDATE_MEMBERSHIP_FAILURE',

  UPDATE_PREFERENCE_REQUEST: 'USERS_UPDATE_PREFERENCE_REQUEST',
  UPDATE_PREFERENCE_SUCCESS: 'USERS_UPDATE_PREFERENCE_SUCCESS',
  UPDATE_PREFERENCE_FAILURE: 'USERS_UPDATE_PREFERENCE_FAILURE',

  UPDATE_SUBLICENSEES_REQUEST: 'USERS_UPDATE_SUBLICENSEES_REQUEST',
  UPDATE_SUBLICENSEES_SUCCESS: 'USERS_UPDATE_SUBLICENSEES_SUCCESS',
  UPDATE_SUBLICENSEES_FAILURE: 'USERS_UPDATE_SUBLICENSEES_FAILURE',

  LIST_SUBLICENSEES_REQUEST: 'USERS_LIST_SUBLICENSEES_REQUEST',
  LIST_SUBLICENSEES_SUCCESS: 'USERS_LIST_SUBLICENSEES_SUCCESS',
  LIST_SUBLICENSEES_FAILURE: 'USERS_LIST_SUBLICENSEES_FAILURE',

  UPDATE_INVITATION_REQUEST: 'USERS_UPDATE_INVITATION_REQUEST',
  UPDATE_INVITATION_SUCCESS: 'USERS_UPDATE_INVITATION_SUCCESS',
  UPDATE_INVITATION_FAILURE: 'USERS_UPDATE_INVITATION_FAILURE',

  UPDATE_EMAIL_REQUEST: 'USERS_UPDATE_EMAIL_REQUEST',
  UPDATE_EMAIL_SUCCESS: 'USERS_UPDATE_EMAIL_SUCCESS',
  UPDATE_EMAIL_FAILURE: 'USERS_UPDATE_EMAIL_FAILURE',

  UPDATE_EMAIL_RESEND_CODE_REQUEST: 'USERS_UPDATE_EMAIL_RESEND_CODE_REQUEST',
  UPDATE_EMAIL_RESEND_CODE_SUCCESS: 'USERS_UPDATE_EMAIL_RESEND_CODE_SUCCESS',
  UPDATE_EMAIL_RESEND_CODE_FAILURE: 'USERS_UPDATE_EMAIL_RESEND_CODE_FAILURE',

  UPDATE_EMAIL_CONFIRMATION_REQUEST: 'USERS_UPDATE_EMAIL_CONFIRMATION_REQUEST',
  UPDATE_EMAIL_CONFIRMATION_SUCCESS: 'USERS_UPDATE_EMAIL_CONFIRMATION_SUCCESS',
  UPDATE_EMAIL_CONFIRMATION_FAILURE: 'USERS_UPDATE_EMAIL_CONFIRMATION_FAILURE',

  UPDATE_PASSWORD_REQUEST: 'USERS_UPDATE_PASSWORD_REQUEST',
  UPDATE_PASSWORD_SUCCESS: 'USERS_UPDATE_PASSWORD_SUCCESS',
  UPDATE_PASSWORD_FAILURE: 'USERS_UPDATE_PASSWORD_FAILURE',

  DELETE_REQUEST: 'USERS_DELETE_REQUEST',
  DELETE_SUCCESS: 'USERS_DELETE_SUCCESS',
  DELETE_FAILURE: 'USERS_DELETE_FAILURE',
};
export default userConstants;
